import '../../style/index.scss';
import './index.scss';
// style dependencies
import '../../mask/style';
import '../../swiper/style';
